import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const DownloadableResources = () => {
    useEffect(() => {
        document.title = 'Downloadable Resources'
    }, []);

    return (
        <>
        <div className='text-page-container'>
            <div className='button-container' style={{padding: '0'}}>
                <Link className='button' to='/'>Back</Link>
            </div>
            <h1>Downloadable Resources</h1>
            <p>If you are going to use the Anki program to drill, as we recommend, all you need is the "Anki Deck."</p>
            <p>If you would like to import the material into a different program (Memrise, Quizlet, Supermemo, etc), you can use the Word List file, which is a spreadsheet with the list of vocab items that go with each lesson, and the collection of audio files supplied here.</p>
            <p>
                <ul>
                    <li><a href='/ojibwe-textbook/download/Ojibwe_KILN_SRS_lessons_20230116.apkg'>Anki Deck</a></li>
                    <li><a href='/ojibwe-textbook/download/Ojibwe_lessons_SRS_material_web.xlsx'>Word List</a></li>
                    <li><a href='/ojibwe-textbook/download/SW_Ojibwe_SRS_media_files.zip'>Audio Files</a></li>
                </ul>
            </p>
        </div>
        <Footer fixed={true}/>
        </>
    )
}

export default DownloadableResources;
